import { render, staticRenderFns } from "./UserAccountPurchasesAutoTopUpAccount.vue?vue&type=template&id=79412ef6&"
import script from "./UserAccountPurchasesAutoTopUpAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchasesAutoTopUpAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports